/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Technicalnecessarydescription2Inputs */



/**
* | output |
* | --- |
* | "Delegator uses technically necessary cookies to enable the use of the app." |
*
* @param {Technicalnecessarydescription2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const technicalnecessarydescription2 = /** @type {((inputs?: Technicalnecessarydescription2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Technicalnecessarydescription2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Delegator uses technically necessary cookies to enable the use of the app.")
	return /** @type {LocalizedString} */ ("Delegator verwendet technisch notwendige Cookies, um das Benutzen der App zu ermöglichen.")
});
export { technicalnecessarydescription2 as "technicalNecessaryDescription" }